module.exports = __webpack_public_path__ + "img/rapiyuda_home_banner_two.c4937f0f.png";